<template>
  <div>
    <h2 class="intro-y text-lg font-medium mt-10">Data List Layout</h2>
    <div class="col-span-12 mt-8">
      <div class="intro-y flex items-center h-10">
        <h2 class="text-lg font-medium truncate mr-5">General Report</h2>
        <a href="" class="ml-auto flex text-theme-1 dark:text-theme-10">
          <RefreshCcwIcon class="w-4 h-4 mr-3" /> Reload Data
        </a>
      </div>
      <div class="grid grid-cols-12 gap-6 mt-5">
        <div class="col-span-12 sm:col-span-6 xl:col-span-3 intro-y">
          <div class="report-box zoom-in">
            <div class="box p-5">
              <div class="flex">
                <CreditCardIcon class="report-box__icon text-theme-11" />
<!--                <div class="ml-auto">-->
<!--                  <Tippy-->
<!--                      tag="div"-->
<!--                      class="report-box__indicator bg-theme-6 cursor-pointer"-->
<!--                      content="2% Lower than last month"-->
<!--                  >-->
<!--                    2% <ChevronDownIcon class="w-4 h-4" />-->
<!--                  </Tippy>-->
<!--                </div>-->
              </div>
              <div class="text-3xl font-bold leading-8 mt-6">{{ordersCount}}</div>
              <div class="text-base text-gray-600 mt-1">Total Orders</div>
            </div>
          </div>
        </div>
<!--        <div class="col-span-12 sm:col-span-6 xl:col-span-3 intro-y">-->
<!--          <div class="report-box zoom-in">-->
<!--            <div class="box p-5">-->
<!--              <div class="flex">-->
<!--                <ShoppingCartIcon class="report-box__icon text-theme-10" />-->
<!--                <div class="ml-auto">-->
<!--                  <Tippy-->
<!--                    tag="div"-->
<!--                    class="report-box__indicator bg-theme-9 cursor-pointer"-->
<!--                    content="33% Higher than last month"-->
<!--                  >-->
<!--                    33% <ChevronUpIcon class="w-4 h-4" />-->
<!--                  </Tippy>-->
<!--                </div>-->
<!--              </div>-->
<!--              <div class="text-3xl font-bold leading-8 mt-6">4.510</div>-->
<!--              <div class="text-base text-gray-600 mt-1">Item Sales</div>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->

<!--        <div class="col-span-12 sm:col-span-6 xl:col-span-3 intro-y">-->
<!--          <div class="report-box zoom-in">-->
<!--            <div class="box p-5">-->
<!--              <div class="flex">-->
<!--                <MonitorIcon class="report-box__icon text-theme-12" />-->
<!--                <div class="ml-auto">-->
<!--                  <Tippy-->
<!--                    tag="div"-->
<!--                    class="report-box__indicator bg-theme-9 cursor-pointer"-->
<!--                    content="12% Higher than last month"-->
<!--                  >-->
<!--                    12% <ChevronUpIcon class="w-4 h-4" />-->
<!--                  </Tippy>-->
<!--                </div>-->
<!--              </div>-->
<!--              <div class="text-3xl font-bold leading-8 mt-6">2.145</div>-->
<!--              <div class="text-base text-gray-600 mt-1">Total Products</div>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
        <div class="col-span-12 sm:col-span-6 xl:col-span-3 intro-y">
          <div class="report-box zoom-in">
            <div class="box p-5">
              <div class="flex">
                <UserIcon class="report-box__icon text-theme-9" />
<!--                <div class="ml-auto">-->
<!--                  <Tippy-->
<!--                    tag="div"-->
<!--                    class="report-box__indicator bg-theme-9 cursor-pointer"-->
<!--                    content="22% Higher than last month"-->
<!--                  >-->
<!--                    22% <ChevronUpIcon class="w-4 h-4" />-->
<!--                  </Tippy>-->
<!--                </div>-->
              </div>
              <div class="text-3xl font-bold leading-8 mt-6">{{users.length}}</div>
              <div class="text-base text-gray-600 mt-1">Total users</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="grid grid-cols-12 gap-6 mt-5">
<!--      <div-->
<!--        class="intro-y col-span-12 flex flex-wrap sm:flex-no-wrap items-center mt-2"-->
<!--      >-->
<!--        <button class="button text-white bg-theme-1 shadow-md mr-2">-->
<!--          Add New Product-->
<!--        </button>-->
<!--        <div class="dropdown">-->
<!--          <button-->
<!--            class="dropdown-toggle button px-2 box text-gray-700 dark:text-gray-300"-->
<!--          >-->
<!--            <span class="w-5 h-5 flex items-center justify-center">-->
<!--              <PlusIcon class="w-4 h-4" />-->
<!--            </span>-->
<!--          </button>-->
<!--          <div class="dropdown-box w-40">-->
<!--            <div class="dropdown-box__content box dark:bg-dark-1 p-2">-->
<!--              <a-->
<!--                href=""-->
<!--                class="flex items-center block p-2 transition duration-300 ease-in-out bg-white dark:bg-dark-1 hover:bg-gray-200 dark:hover:bg-dark-2 rounded-md"-->
<!--              >-->
<!--                <PrinterIcon class="w-4 h-4 mr-2" /> Print-->
<!--              </a>-->
<!--              <a-->
<!--                href=""-->
<!--                class="flex items-center block p-2 transition duration-300 ease-in-out bg-white dark:bg-dark-1 hover:bg-gray-200 dark:hover:bg-dark-2 rounded-md"-->
<!--              >-->
<!--                <FileTextIcon class="w-4 h-4 mr-2" /> Export to Excel-->
<!--              </a>-->
<!--              <a-->
<!--                href=""-->
<!--                class="flex items-center block p-2 transition duration-300 ease-in-out bg-white dark:bg-dark-1 hover:bg-gray-200 dark:hover:bg-dark-2 rounded-md"-->
<!--              >-->
<!--                <FileTextIcon class="w-4 h-4 mr-2" /> Export to PDF-->
<!--              </a>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
<!--        <div class="hidden md:block mx-auto text-gray-600">-->
<!--          Showing 1 to 10 of 150 entries-->
<!--        </div>-->
<!--        <div class="w-full sm:w-auto mt-3 sm:mt-0 sm:ml-auto md:ml-0">-->
<!--          <div class="w-56 relative text-gray-700 dark:text-gray-300">-->
<!--            <input-->
<!--              type="text"-->
<!--              class="input w-56 box pr-10 placeholder-theme-13"-->
<!--              placeholder="Search..."-->
<!--            />-->
<!--            <SearchIcon-->
<!--              class="w-4 h-4 absolute my-auto inset-y-0 mr-3 right-0"-->
<!--            />-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->

      <div class="hidden md:block mx-auto text-gray-800">
        Settings

        <h2
            class="intro-x font-bold text-2xl xl:text-3xl text-center xl:text-left"
        >
          Bionet parser
        </h2>
        <div class="intro-x mt-8">
          <input
              v-model="bionet.email"
              type="text"
              class="intro-x login__input w-full input input--lg border border-gray-300 block"
              placeholder="Email"
          />
          <input
              v-model="bionet.lat"
              type="text"
              class="intro-x login__input w-full input input--lg border border-gray-300 block mt-4"
              placeholder="lat"
          />
          <input
              v-model="bionet.lon"
              type="text"
              class="intro-x login__input w-full input input--lg border border-gray-300 block mt-4"
              placeholder="lon"
          />
        </div>
        <br>

        <div
            v-if="infoError === true "
            class="rounded-md flex items-center px-5 py-4 mb-2 bg-theme-6 text-white"
        >
          <AlertOctagonIcon class="w-6 h-6 mr-2" />
          Parser was run. When finished will be sent to email from form.
        </div>

        <div class="intro-x mt-5 xl:mt-8 text-center xl:text-left">
          <button
              class="button button--lg w-full xl:w-32 text-white bg-theme-1 xl:mr-3 align-top"
              @click="submitBionet"
          >
            Run
          </button>
        </div>
      </div>





      <div class="col-span-12 lg:col-span-12 xxl:col-span-12">
        <!-- BEGIN: Announcement -->
        <div class="intro-y box mt-5">
          <div
            class="flex items-center px-5 py-3 border-b border-gray-200 dark:border-dark-5"
          >
            <h3 class="text-2xl text-theme-1 font-medium leading-none">
              Some of our clients
            </h3>
          </div>
          <div class="px-5">
          </div>
            <div class="font-medium">

              <img

                :src="require(`@/assets/images/Clients_Banner.svg`)"
                align = "middle"
                justify = "centre"

              />
            </div>

          </div>
        </div>






      <div class="intro-y col-span-12 overflow-auto lg:overflow-visible">
        <table class="table table-report -mt-2">
          <thead>
          <tr>
            <th class="text-center whitespace-no-wrap">Email</th>
            <th class="text-center whitespace-no-wrap">Phone</th>
            <th class="text-center whitespace-no-wrap">Telegram</th>
            <th class="text-center whitespace-no-wrap">Product Price</th>
            <th class="text-center whitespace-no-wrap">ACTIONS</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(item, itemKey) in settings" :key="itemKey" class="intro-x">
            <td class="text-center">
              {{ item.email }}
            </td>
            <td class="text-center">{{ item.phone }}</td>
            <td class="text-center">{{ item.telegram }}</td>
            <td class="text-center">{{ item.product_price }} AUD</td>
            <!--              <td class="w-40">-->
            <!--                <div-->
            <!--                  class="flex items-center justify-center"-->
            <!--                  :class="{-->
            <!--                    'text-theme-9': faker.true_false[0],-->
            <!--                    'text-theme-6': !faker.true_false[0]-->
            <!--                  }"-->
            <!--                >-->
            <!--                  <CheckSquareIcon class="w-4 h-4 mr-2" />-->
            <!--                  {{ faker.true_false[0] ? "Active" : "Inactive" }}-->
            <!--                </div>-->
            <!--              </td>-->
            <td class="table-report__action w-56">
              <div class="flex justify-center items-center">
                <a class="flex items-center mr-3"
                   href="javascript:;"
                   data-toggle="modal"
                   data-target="#edit-settings-modal"
                   @click="editItemSettings(item)"
                >
                  <CheckSquareIcon class="w-4 h-4 mr-1" />
                  Edit
                </a>
              </div>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
      <div class="hidden md:block mx-auto">
        Users
      </div>
      <!-- BEGIN: Data List -->
      <div class="intro-y col-span-12 overflow-auto lg:overflow-visible">
        <table class="table table-report -mt-2">
          <thead>
            <tr>
              <th class="text-center whitespace-no-wrap">NAME</th>
              <th class="text-center whitespace-no-wrap">Email</th>
              <th class="text-center whitespace-no-wrap">ADDRESS</th>
              <th class="text-center whitespace-no-wrap">ACTIONS</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(user, userKey) in users" :key="userKey" class="intro-x">
              <td class="text-center">
                {{ user.first_name + " " + user.last_name }}
              </td>
              <td class="text-center">{{ user.email }}</td>
              <td class="text-center">{{ user.address }}</td>
              <!--              <td class="w-40">-->
              <!--                <div-->
              <!--                  class="flex items-center justify-center"-->
              <!--                  :class="{-->
              <!--                    'text-theme-9': faker.true_false[0],-->
              <!--                    'text-theme-6': !faker.true_false[0]-->
              <!--                  }"-->
              <!--                >-->
              <!--                  <CheckSquareIcon class="w-4 h-4 mr-2" />-->
              <!--                  {{ faker.true_false[0] ? "Active" : "Inactive" }}-->
              <!--                </div>-->
              <!--              </td>-->
              <td class="table-report__action w-56">
                <div class="flex justify-center items-center">
                  <a class="flex items-center mr-3"
                     href="javascript:;"
                     data-toggle="modal"
                     data-target="#edit-modal"
                     @click="editItem(user)"
                  >
                    <CheckSquareIcon class="w-4 h-4 mr-1" />
                    Edit
                  </a>
                  <a
                    class="flex items-center text-theme-6"
                    href="javascript:;"
                    data-toggle="modal"
                    data-target="#delete-confirmation-modal"
                    @click="deleteItem(user)"
                  >
                    <Trash2Icon class="w-4 h-4 mr-1" /> Delete
                  </a>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <!-- END: Data List -->
      <!-- BEGIN: Pagination -->
      <!-- END: Pagination -->
    </div>
    <div id="edit-settings-modal" class="modal">
      <div class="modal__content">
        <div class="p-5 text-center">
          <div class="text-3xl mt-5"></div>
          <div class="grid grid-cols-12 gap-5">
            <div class="col-span-12 xl:col-span-6">
              <div class="mt-3">
                <label>Email</label>
                <input
                    type="text"
                    class="input w-full border mt-2"
                    placeholder="Email"
                    v-model="editedItemSettings.email"
                />
              </div>
              <div class="mt-3">
                <label>Phone</label>
                <input
                    type="text"
                    class="input w-full border mt-2"
                    placeholder="Phone"
                    v-model="editedItemSettings.phone"
                />
              </div>
            </div>
            <div class="col-span-12 xl:col-span-6">
              <div class="mt-3">
                <label>Telegram</label>
                <input
                    type="text"
                    class="input w-full border mt-2"
                    placeholder="telegram"
                    v-model="editedItemSettings.telegram"
                />
              </div>
              <div class="mt-3">
                <label>Price</label>
                <input
                    type="text"
                    class="input w-full border mt-2"
                    placeholder="price"
                    v-model="editedItemSettings.product_price"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="px-5 pb-8 text-center">
          <button
              type="button"
              data-dismiss="modal"
              class="button w-24 border text-gray-700 mr-1"
          >
            Cancel
          </button>
          <button type="button" class="button w-20 bg-theme-1 text-white ml-auto" data-dismiss="modal" @click="saveSettings">
            Save
          </button>
        </div>
      </div>
    </div>
    <!-- BEGIN: Edit Modal -->
    <div id="edit-modal" class="modal">
      <div class="modal__content">
        <div class="p-5 text-center">
          <div class="text-3xl mt-5"></div>
          <div class="grid grid-cols-12 gap-5">
            <div class="col-span-12 xl:col-span-6">
              <div>
                <label>Email</label>
                <input
                    type="text"
                    class="input w-full border mt-2"
                    placeholder="Email"
                    v-model="editedItem.email"
                />
              </div>
              <div class="mt-3">
                <label>First name</label>
                <input
                    type="text"
                    class="input w-full border mt-2"
                    placeholder="first name"
                    v-model="editedItem.first_name"
                />
              </div>
              <div class="mt-3">
                <label>Company</label>
                <input
                    type="text"
                    class="input w-full border mt-2"
                    placeholder="company"
                    v-model="editedItem.company"
                />
              </div>
            </div>
            <div class="col-span-12 xl:col-span-6">
              <div>
                <label>Address</label>
                <input
                    type="text"
                    class="input w-full border mt-2"
                    placeholder="address"
                    v-model="editedItem.address"
                />
              </div>
              <div class="mt-3">
                <label>Last name</label>
                <input
                    type="text"
                    class="input w-full border mt-2"
                    placeholder="last name"
                    v-model="editedItem.last_name"
                />
              </div>
              <div class="mt-3">
                <label>Enter new password</label>
                <input
                    type="text"
                    class="input w-full border mt-2"
                    placeholder="password"
                    v-model="editedItem.password"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="px-5 pb-8 text-center">
          <button
              type="button"
              data-dismiss="modal"
              class="button w-24 border text-gray-700 mr-1"
          >
            Cancel
          </button>
          <button type="button" class="button w-20 bg-theme-1 text-white ml-auto" data-dismiss="modal" @click="save">
            Save
          </button>
        </div>
      </div>
    </div>
    <!-- END: Edit Modal -->
    <!-- BEGIN: Delete Confirmation Modal -->
    <div id="delete-confirmation-modal" class="modal">
      <div class="modal__content">
        <div class="p-5 text-center">
          <xCircleIcon class="w-16 h-16 text-theme-6 mx-auto mt-3" />
          <div class="text-3xl mt-5">Are you sure?</div>
          <div class="text-gray-600 mt-2">
            Do you really want to delete these user? This process cannot be
            undone.
          </div>
        </div>
        <div class="px-5 pb-8 text-center">
          <button
            type="button"
            data-dismiss="modal"
            class="button w-24 border text-gray-700 mr-1"
          >
            Cancel
          </button>
          <button type="button"
                  class="button w-24 bg-theme-6 text-white"
                  data-dismiss="modal"
                  @click="deleteUser"
          >
            Delete
          </button>
        </div>
      </div>
    </div>
    <!-- END: Delete Confirmation Modal -->
  </div>
</template>
<script>
import xlsx from "xlsx";
import feather from "feather-icons";
import axios from "axios";
// import Tabulator from "tabulator-tables";

export default {
  data() {
    return {
      infoError: false,
      bionet: {
        email: undefined,
        lat: undefined,
        lon: undefined
      },
      bionetDefault: {
        email: undefined,
        lat: undefined,
        lon: undefined
      },
      users: null,
      ordersCount: null,
      settings: null,
      editedIndex: -1,
      editedIndexSettings: -1,
      itemToDelete: {
        id: undefined,
        email: undefined,
        first_name: undefined,
        last_name: undefined,
        password: undefined,
        address: undefined,
        company: undefined,
      },
      editedItemSettings: {
        id: undefined,
        email: undefined,
        phone: undefined,
        telegram: undefined,
        product_price: undefined,
      },
      editedItem: {
        id: undefined,
        email: undefined,
        first_name: undefined,
        last_name: undefined,
        password: undefined,
        address: undefined,
        company: undefined,
      },
      defaultItem: {
        id: undefined,
        email: undefined,
        first_name: undefined,
        last_name: undefined,
        password: undefined,
        address: undefined,
        company: undefined,
      },
      dialog: false,
      filter: {
        field: "name",
        type: "like",
        value: ""
      }
    };
  },
  mounted() {
    this.getOrdersCount();
    this.getUsers();
    this.getSettings();
    // Redraw table onresize
    window.addEventListener("resize", () => {
      this.table.redraw();
      feather.replace({
        "stroke-width": 1.5
      });
    });
  },
  methods: {
    // Filter function
    onFilter() {
      this.table.setFilter(
        this.filter.field,
        this.filter.type,
        this.filter.value
      );
    },
    deleteItem(item) {
      this.itemToDelete = item
    },
    deleteUser() {
      const index = this.users.indexOf(this.itemToDelete)
      axios.delete('user/delete/' + this.itemToDelete.id)
          .then(() => {
            this.users.splice(index, 1)
            this.itemToDelete = this.defaultItem
          })
    },
    close() {
      this.dialog = false
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 300)
    },
    submitBionet() {
      axios.post('bionet/add', this.bionet)
          .then(response => {
            console.log(response.data)
            this.bionet = this.bionetDefault
            this.infoError = true
          });
    },
    saveSettings() {
      if (this.editedIndexSettings > -1) {
        axios.put('update/settings/' + this.editedItemSettings.id, this.editedItemSettings)
            .then(response => {
              console.log(response.data)
              Object.assign(this.settings[this.editedIndexSettings], this.editedItemSettings)

              this.close()
            });
      }
    },
    save() {
      if (this.editedIndex > -1) {
        axios.put('admin/user/update/' + this.editedItem.id, this.editedItem)
            .then(response => {
              console.log(response.data)
              Object.assign(this.users[this.editedIndex], this.editedItem)

              this.close()
            });
      }
    },

    editItemSettings(item) {
      this.editedIndexSettings = this.settings.indexOf(item)
      this.editedItemSettings = Object.assign({}, item)
    },

    editItem(item) {
      this.editedIndex = this.users.indexOf(item)
      this.editedItem = Object.assign({}, item)
    },

    getSettings() {
      axios
          .get("pmst/settings/")
          .then(response => {
            let data = response.data;
            this.settings = data;
          })
          .catch(function(error) {
            console.error(error.response);
          });
    },

    getOrdersCount() {
      axios
          .get("all/orders/")
          .then(response => {
            let data = response.data;
            this.ordersCount = data.count;
          })
          .catch(function(error) {
            console.error(error.response);
          });
    },

    getUsers() {
      axios
        .get("users/")
        .then(response => {
          let data = response.data;
          this.users = data;
        })
        .catch(function(error) {
          console.error(error.response);
        });
    },

    // On reset filter
    onResetFilter() {
      this.filter.field = "name";
      this.filter.type = "like";
      this.filter.value = "";
      this.onFilter();
    },

    // Export
    onExportCsv() {
      this.table.download("csv", "data.csv");
    },
    onExportJson() {
      this.table.download("json", "data.json");
    },
    onExportXlsx() {
      window.XLSX = xlsx;
      this.table.download("xlsx", "data.xlsx", {
        sheetName: "Products"
      });
    },

    // Print
    onPrint() {
      this.table.print();
    }
  }
};
</script>
